export const AI_AGENT_LANGUAGES = [
  { code: "am", label: "armenian", flag: "🇦🇲" },
  { code: "en", label: "english", flag: "🇺🇸" },
];